export default __webpack_public_path__ + "static/media/MedPng.fe76b3a8.jpg";